import { createContext, Dispatch, SetStateAction } from "react";

export const PasswordContext = createContext<{
  newPassword: string;
  setNewPassword: Dispatch<SetStateAction<string>>;
  confirmNewPassword: string;
  setConfirmNewPassword: Dispatch<SetStateAction<string>>;
}>({
  newPassword: "",
  setNewPassword: () => null,
  confirmNewPassword: "",
  setConfirmNewPassword: () => null,
});
